import cx from 'classnames'
import { type FC, useCallback, useState } from 'react'

import { ResizeObservedWrapper } from '../ResizeObservedWrapper'
import CheckboxSubTree from './CheckboxSubTree'
import css from './CheckboxTree.module.scss'
import type { CheckboxTreeState } from './types'
import { setCheckedAndAllChildren, updateParentStatus } from './utils'

type Props = {
  state: CheckboxTreeState
  onChange: (state: CheckboxTreeState) => void
  className?: string
}

const CheckboxTree: FC<Props> = ({ state, onChange, className }) => {
  const [height, setHeight] = useState<number | null>(null)

  const toggleStatus = useCallback(
    (id: string, status: boolean) => {
      const clonedState = new Map(state)
      setCheckedAndAllChildren(clonedState, id, status)
      if (state.get(id)) {
        updateParentStatus(clonedState, clonedState.get(id)!.parentId)
      }
      onChange(clonedState)
    },
    [state]
  )

  const rootId = Array.from(state.keys()).find(
    (id) => state.get(id) && state.get(id)!.parentId === null
  )

  if (!rootId) {
    return null
  }

  return (
    <div className={css.outerWrapper}>
      <div
        style={{ height: `${height}px` }}
        className={cx(css.wrapper, className)}
      >
        {/* @ts-ignore */}
        <ResizeObservedWrapper onResize={setHeight}>
          <CheckboxSubTree
            data={state}
            nodeId={rootId}
            toggleStatus={toggleStatus}
          />
        </ResizeObservedWrapper>
      </div>
    </div>
  )
}

export default CheckboxTree
